export function offset(el, parent) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = parent ? parent.scrollLeft : (window.pageXOffset || document.documentElement.scrollLeft),
        scrollTop = parent ? parent.scrollTop : (window.pageYOffset || document.documentElement.scrollTop);

    return {top: rect.top + scrollTop, left: rect.left + scrollLeft};
}

export function getScrollOffset(el, parent, header) {
    let headerHeight = (header || document.querySelector('.header-wrap')).offsetHeight || 0;

    return Math.max(0, offset(el, parent).top - headerHeight - 30);
}

export function scrollWithOffset(el, parent, header) {
    return new Promise((resolve, reject) => {
        let container = parent ? parent : window,
            topPosition = getScrollOffset(el, parent, header),
            currPosition = parent ? parent.scrollTop : (window.pageYOffset || document.documentElement.scrollTop),
            onScroll = () => {
                let scrollTop = parent ? parent.scrollTop : (window.pageYOffset || document.documentElement.scrollTop)

                if (Math.abs(scrollTop - topPosition) < 1) {
                    container.removeEventListener('scroll', onScroll)
                    resolve();
                }
            };

        if (Math.abs(currPosition - topPosition) < 1) {
            resolve();
        } else {
            container.addEventListener('scroll', onScroll);
            container.scrollTo({top: topPosition, left: 0, behavior: 'smooth'});
        }
    });
}

export function triggerEvent($el, eventName, data) {
    let event = new CustomEvent(eventName, {
        bubbles: true,
        detail: data
    });
    $el.dispatchEvent(event);
}

export function toggleBodyScroll(doLock) {
    if (doLock) {
        let _cacheScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (document.body.classList.contains('headroom--top')) {
            document.body.classList.add('no-scroll--top');
        } else if (document.body.classList.contains('headroom--not-top')) {
            document.body.classList.add('no-scroll--not-top');
        }

        document.body.dataset['scrollTop'] = `${_cacheScrollTop}`;
        document.body.style.top = -_cacheScrollTop + 'px';
        document.body.classList.add('no-scroll');
    } else {
        let _cacheScrollTop = parseFloat(document.body.dataset['scrollTop']||'0');

        document.body.classList.remove('no-scroll');
        document.body.classList.remove('no-scroll--top');
        document.body.classList.remove('no-scroll--not-top');
        document.body.style.top = '';
        window.scrollTo(0, _cacheScrollTop);
    }
}

export function storageAvailable(type) {
    try {
        let storage = window[type],
            x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return false;
    }
}

export function getFromTemplate(htmlString) {
    let div = document.createElement('div');
    div.innerHTML = htmlString.trim();
    return div.firstChild;
}

export function checkVerticalresize(previousWidth, callback) {
    let windowWidth = document.documentElement.clientWidth;

    if (previousWidth !== windowWidth) {
        if (typeof callback === 'function') {
            callback(windowWidth);
        }
    }
}

export function getHeight($element, fullClassname, timeout = 200, callback) {
    let height;

    $element.classList.add(fullClassname);
    $element.classList.add('no-animation');
    height = $element.offsetHeight;
    if (typeof callback === 'function') {
        callback($element);
    }
    $element.classList.remove(fullClassname);
    setTimeout(() => {
        $element.classList.remove('no-animation');
    }, timeout);

    return height;
}

export function getQueryParams() {
    let params = {},
        parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
        function(m,key,value) {
            params[key] = decodeURIComponent(value);
        });
    return params;
}

export const isIE = () => {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    return msie > 0 || !!navigator.userAgent.match( /Trident\/|MSIE/);
};

export function wrapInner(parent, wrapper, attribute, attributevalue) {
    if (typeof wrapper === 'string') {
        wrapper = document.createElement(wrapper);
    }

    let div = parent.appendChild(wrapper);

    if (attribute !== undefined) {
        div.setAttribute(attribute, attributevalue);
    }

    while (parent.firstChild !== wrapper) {
        wrapper.appendChild(parent.firstChild);
    }
}

export function autoOpen(elemClassName) {
    if (window.location.hash) {
        let id = window.location.hash.substr(1),
            $item = document.querySelector(`${elemClassName}[data-id="${id}"]`);

        if ($item) {
            scrollWithOffset($item).then(() => {
                $item.click();
            });
        }
    }
}
